import jstz from 'jstz';

export default (date) => {
    const timezone = jstz.determine();
    const name = timezone.name() || 'America/Los_Angeles';

    return new Date(date).toLocaleString("en-US", { timeZone: name });
};